
const LogoIcon = () => {
  const fill = '#FF462D';

  return (
    <svg
      width="18"
      height="28"
      viewBox="0 0 18 28"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="K"
      role="img"
    >
      <text
        x="0"
        y="21"
        fontFamily="'TWK Everett', sans-serif"
        fontWeight={500}
        fontSize="22"
        fill={fill}
        letterSpacing="-0.02em"
      >
        k
      </text>
    </svg>
  );
};

export default LogoIcon;
